import {connect} from 'react-redux';
import SimpleSelector from 'gui/components/simpleSelector';
import {services} from "../../reducers/feathersReducers";
import {createSelector} from "redux-starter-kit";

const areasSelector = createSelector(["areasService.queryResult.data"]);
const mapStateToProps = (state) => {
  const options = areasSelector(state).map((area) => ({label: area.label, value: area.id}));
  return {
    options,
    isMulti: false,
    fakeMulti: true,
    // closeMenuOnSelect: false,
  };
};


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onLoad: (props) => {
      if (props.options.length <= 0) {
        dispatch(services.areas.find());
      }
    }
  };
};


const AreaSelectorContainer = connect(mapStateToProps, mapDispatchToProps)(SimpleSelector);

export default AreaSelectorContainer;
